import { FormGroup, Label, Select } from 'idsk-react-components';
import React, { ReactElement, useEffect, useState } from 'react';
import StavPripomienky, { stavPripomienkyValues } from '../../../model/pripomienka/StavPripomienky';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import AddVyhodnotenie from '../../../model/pripomienka/AddVyhodnotenie';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';

interface Props {
  stavFromDetail?: StavPripomienky;
  updateField: SafeParameterSetter<AddVyhodnotenie>;
}

const VyhodnotenieSelectBox = ({ stavFromDetail, updateField }: Props): ReactElement => {
  const { clearFieldErrorMessage, getFieldErrorMessage } = useFieldErrorMessages();

  const [selectedStav, setSelectedStav] = useState(stavFromDetail || StavPripomienky.NESPRACOVANA);

  useEffect(() => {
    updateField('stavPripomienky', selectedStav);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStav]);

  const onSelectChange = (e): void => {
    const { value } = e.target;
    setSelectedStav(value);
    updateField('stavPripomienky', value);
    clearFieldErrorMessage('stavPripomienky');
  };

  return (
    <FormGroup error={!!getFieldErrorMessage('stavPripomienky')}>
      <Label htmlFor="vyhodnotenie">Vyhodnotenie</Label>
      <Select
        id="vyhodnotenie"
        width="one-quarter"
        value={selectedStav}
        onChange={onSelectChange}
        error={getFieldErrorMessage('stavPripomienky')}
      >
        {stavPripomienkyValues.map((stavPripomienkyValue) => (
          <option key={stavPripomienkyValue} value={stavPripomienkyValue}>{stavPripomienkyValue}</option>
        ))}
      </Select>
    </FormGroup>
  );
};

export default VyhodnotenieSelectBox;
